import React from 'react';
import styled from 'styled-components';
import Title from '../title';

const SkiTransfersSection = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -150px;
    position: relative;
`;

const SkiTransfersSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    width: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
    background-position: top;
    padding-top: 700px;
    padding-bottom: 15vh;
`;

const ContactSection = () => {
    return (
        <SkiTransfersSection>
            <img 
                src={require('../../../assets/images/mercedes-set.png')} 
                alt="Mercedes Set" 
                style={{
                    position: 'absolute',
                    height: '600px',
                    width: 'auto',
                    top: '-15px',
                    zIndex: 99,
                    border: '15px solid white',
                    boxShadow: 'rgba(0, 0, 0, 0.10) 0px 0px 25px 0px',
                }}
            />
            <SkiTransfersSectionContainer className='bg-contact'>
                <h1 className="text-4xl font-['Montserrat'] uppercase text-[#FFFFFF] [text-shadow:_1px_1px_5px_rgb(6_202_255_/_60%)]">
                    +33 6 26 52 18 44
                </h1>
                <h1 className="text-4xl font-['Montserrat'] uppercase text-[#FFFFFF] [text-shadow:_1px_1px_5px_rgb(6_202_255_/_60%)] mt-[25px]">
                    reservations@mont-blanc-transfers.com
                </h1>
            </SkiTransfersSectionContainer>
        </SkiTransfersSection>
    );
}

export default ContactSection;